<mode-encoding-pill-base
  [title]="title"
  [displayName]="displayName"
  [isValid]="isValid"
  [isAnalyticCalc]="false"
  [isDiscrete]="isDiscrete"
  [isContinuous]="isContinuous"
  [isDualAxis]="false"
  [isSharedAxis]="false"
  [isDualAxisRelative]="false"
  [tooltipContent]="topByFieldTooltipContent"
  [secondaryIcon]="topByFieldIcon"
  [secondaryIconClass]="caretIcon"
  [errorMessage]="errorMessage"
  [caretIcon]="caretIcon"
  [contextMenu]="menu"
  [contextMenuSubject]="field"
  (showMenu)="showContextMenu($event)"
  (dblclick)="handleDoubleClick($event)"
>
  <context-menu>
    <ng-container *ngIf="isValid">
      <ng-template contextMenuItem (execute)="onEditFilter()">
        <span><span class="context-link-name">Edit Filter...</span></span>
      </ng-template>
      <ng-template contextMenuItem [divider]="true"></ng-template>
    </ng-container>

    <!-- Date Options -->
    <ng-container *ngIf="isDateExpr">
      <!-- Date Trunc Options -->
      <ng-template contextMenuItem [enabled]="false" [passive]="true">
        <span class="context-heading-item">
          <capra-icon class="continuous" icon="icon-field-date"></capra-icon>
          <span class="context-heading">Dates and Times</span>
        </span>
      </ng-template>
      <ng-container *ngFor="let dateTruncOpt of dateTruncOpts">
        <ng-template contextMenuItem (execute)="setDateTrunc(dateTruncOpt.unit)">
          <span [class.selected]="dateTruncOpt.isSelected"
            ><span class="indicator"></span><span class="context-link-name">{{ dateTruncOpt.label }}</span
            ><span class="context-link-aside">{{ dateTruncOpt.formatted }}</span></span
          >
        </ng-template>
      </ng-container>
      <ng-template contextMenuItem [subMenu]="dateTruncMoreMenu">More</ng-template>
      <context-menu #dateTruncMoreMenu>
        <ng-container *ngFor="let dateTruncOpt of dateTruncMoreOpts">
          <ng-template contextMenuItem (execute)="setDateTrunc(dateTruncOpt.unit)">
            <span [class.selected]="dateTruncOpt.isSelected"
              ><span class="indicator"></span><span class="context-link-name">{{ dateTruncOpt.label }}</span
              ><span class="context-link-aside">{{ dateTruncOpt.formatted }}</span></span
            >
          </ng-template>
        </ng-container>
      </context-menu>
      <ng-template contextMenuItem [divider]="true"></ng-template>

      <!-- Date Part Options -->
      <ng-template contextMenuItem [enabled]="false" [passive]="true">
        <span class="context-heading-item"
          ><capra-icon class="discrete" icon="icon-field-date"></capra-icon
          ><span class="context-heading">Date Parts</span></span
        >
      </ng-template>
      <ng-container *ngFor="let datePartOpt of datePartOpts">
        <ng-template contextMenuItem (execute)="setDatePart(datePartOpt.unit)">
          <span [class.selected]="datePartOpt.isSelected"
            ><span class="indicator"></span><span class="context-link-name">{{ datePartOpt.label }}</span
            ><span class="context-link-aside">{{ datePartOpt.formatted }}</span></span
          >
        </ng-template>
      </ng-container>
      <ng-template contextMenuItem [subMenu]="datePartMoreMenu">More</ng-template>
      <context-menu #datePartMoreMenu>
        <ng-container *ngFor="let datePartOpt of datePartMoreOpts">
          <ng-template contextMenuItem (execute)="setDatePart(datePartOpt.unit)">
            <span [class.selected]="datePartOpt.isSelected"
              ><span class="indicator"></span><span class="context-link-name">{{ datePartOpt.label }}</span
              ><span class="context-link-aside">{{ datePartOpt.formatted }}</span></span
            >
          </ng-template>
        </ng-container>
      </context-menu>
      <ng-template contextMenuItem [divider]="true"></ng-template>

      <!-- Start of year & Start of week-->
      <ng-template contextMenuItem [subMenu]="yearStartsMenu">Year start</ng-template>
      <context-menu #yearStartsMenu>
        <ng-container *ngFor="let ys of yearStartOptions">
          <ng-template contextMenuItem (execute)="setYearStart(ys.value)">
            <span [class.selected]="yearStart === ys.value">
              <span class="indicator"></span>
              <span class="context-link-name">{{ ys.name }}</span>
              <span *ngIf="(isCustomCalenderSettingsEnabled$ | async) && defaultYearStart === ys.value" class="context-link-aside">Org Default</span>
            </span>
          </ng-template>
        </ng-container>
      </context-menu>

      <ng-template contextMenuItem [subMenu]="weekStartsMenu">Week start</ng-template>
      <context-menu #weekStartsMenu>
        <ng-container *ngFor="let ws of weekStartOptions">
          <ng-template contextMenuItem (execute)="setWeekStart(ws.value)">
            <span [class.selected]="weekStart === ws.value">
              <span class="indicator"></span>
              <span class="context-link-name">{{ ws.name }}</span>
              <span *ngIf="(isCustomCalenderSettingsEnabled$ | async) && defaultWeekStart === ws.value" class="context-link-aside">Org Default</span>
            </span>
          </ng-template>
        </ng-container>
      </context-menu>

      <ng-template contextMenuItem [divider]="true"></ng-template>

      <!-- Exact Date/Time -->
      <ng-template contextMenuItem (execute)="setExactDateTime()">
        <span [class.selected]="isExactDateAndTime"
          ><span class="indicator"></span><span class="context-link-name">Exact date and time</span></span
        >
      </ng-template>
      <ng-template contextMenuItem [divider]="true"></ng-template>
    </ng-container>

    <!-- Discrete/Continuous -->
    <ng-container *ngIf="hasVarTypeMenuOpts">
      <ng-template contextMenuItem (execute)="setVariableType(variableDiscrete)">
        <span [class.selected]="formula.isDiscrete"
          ><span class="indicator"></span><span class="context-link-name">Discrete</span></span
        >
      </ng-template>
      <ng-template contextMenuItem (execute)="setVariableType(variableContinuous)">
        <span [class.selected]="formula.isContinuous"
          ><span class="indicator"></span><span class="context-link-name">Continuous</span></span
        >
      </ng-template>
      <ng-template contextMenuItem [divider]="true"></ng-template>
    </ng-container>

    <!-- TopN options-->
    <ng-container *ngIf="hasTopByFieldOptions">
      <ng-template contextMenuItem (execute)="setSequence(TopByFieldSequence.FirstIsolate)">
        <span [class.selected]="topByFieldSequence === TopByFieldSequence.FirstIsolate"
          ><span class="indicator"></span><span class="context-link-name">Apply first</span></span
        >
      </ng-template>
      <ng-template contextMenuItem (execute)="setSequence(TopByFieldSequence.LastIsolate)">
        <span [class.selected]="topByFieldSequence === TopByFieldSequence.LastIsolate"
          ><span class="indicator"></span><span class="context-link-name">Apply last</span></span
        >
      </ng-template>
      <ng-template contextMenuItem [divider]="true"></ng-template>
    </ng-container>

    <!-- Remove -->
    <ng-template contextMenuItem (execute)="removeField()">
      <span><span class="context-link-name">Remove</span></span>
    </ng-template>
  </context-menu>
</mode-encoding-pill-base>
